import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.module.css";

const Input = ({
  label,
  type = "text",
  value,
  onChange,
  onInput,
  onFocus,
  onKeyDown,
  placeholder,
  error,
  id,
  name,
  autoFocus,
  showPasswordToggle,
  onTogglePassword,
  disabled,
  className,
  inputClassName,
}) => {
  const isPassword = type === "password" || showPasswordToggle;
  const inputType = type;
  const handleChange = (e) => {
    if (onChange) onChange(e.target.value);
    if (onInput) onInput(e);
  };

  return (
    <div className={`${styles.inputContainer} ${className || ""}`.trim()}>
      {label && (
        <label htmlFor={id} className={styles.label}>
          {label}
        </label>
      )}
      <div className={styles.inputWrapper}>
        <input
          id={id}
          name={name}
          type={inputType}
          value={value}
          onChange={handleChange}
          onInput={onInput}
          onFocus={onFocus}
          onKeyDown={onKeyDown}
          placeholder={placeholder}
          autoFocus={autoFocus}
          disabled={disabled}
          className={`${styles.input} ${isPassword ? styles.inputWithIcon : ""} ${error ? styles.inputError : ""} ${inputClassName || ""}`.trim()}
          aria-invalid={!!error}
          aria-describedby={error ? `${id}-error` : undefined}
        />
        {showPasswordToggle && (
          <span
            role="button"
            tabIndex={0}
            className={styles.eyeIcon}
            onClick={onTogglePassword}
            onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && onTogglePassword?.()}
            aria-label={type === "password" ? "Show password" : "Hide password"}
          >
            {type === "password" ? (
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24" />
                <line x1="1" y1="1" x2="23" y2="23" />
              </svg>
            ) : (
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                <circle cx="12" cy="12" r="3" />
              </svg>
            )}
          </span>
        )}
      </div>
      {error && (
        <span id={id ? `${id}-error` : undefined} className={styles.errorMessage}>
          {error}
        </span>
      )}
    </div>
  );
};

Input.propTypes = {
  label: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  onInput: PropTypes.func,
  onFocus: PropTypes.func,
  onKeyDown: PropTypes.func,
  placeholder: PropTypes.string,
  error: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
  autoFocus: PropTypes.bool,
  showPasswordToggle: PropTypes.bool,
  onTogglePassword: PropTypes.func,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  inputClassName: PropTypes.string,
};

export default Input;
